/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerSkipProcessingMutationResponse, DocumentUseCasesControllerSkipProcessingPathParams, DocumentUseCasesControllerSkipProcessing400, DocumentUseCasesControllerSkipProcessing401, DocumentUseCasesControllerSkipProcessing403, DocumentUseCasesControllerSkipProcessing404 } from "../../models/documentUseCasesController/DocumentUseCasesControllerSkipProcessing";

function getDocumentUseCasesControllerSkipProcessingUrl(processingId: DocumentUseCasesControllerSkipProcessingPathParams["processingId"]) {
  const res = { method: 'POST', url: `/api/v1/documents/processings/${processingId}/skip` as const }  
  return res
}

/**
 * @description Excuses a FAILED processing workflow that cannot be made to succeed by transitioning it to SKIPPED (preserving its failed steps/errors as audit), then re-reconciles the file so it can reach READY on its remaining successful workflows. Only FAILED processings can be skipped.
 * @summary Skip a failed processing workflow
 * {@link /api/v1/documents/processings/:processingId/skip}
 */
export async function documentUseCasesControllerSkipProcessing(processingId: DocumentUseCasesControllerSkipProcessingPathParams["processingId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerSkipProcessingMutationResponse, ResponseErrorConfig<DocumentUseCasesControllerSkipProcessing400 | DocumentUseCasesControllerSkipProcessing401 | DocumentUseCasesControllerSkipProcessing403 | DocumentUseCasesControllerSkipProcessing404>, unknown>({ method : "POST", url : getDocumentUseCasesControllerSkipProcessingUrl(processingId).url.toString(), ... requestConfig })  
  return res.data
}